import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, IconButton } from '@mui/material';
import { useNavigate } from 'react-router';
import HomeIcon from '@mui/icons-material/Home';
import DynamicBreadcrumbs from '../Shared/Breadcrumb/index.tsx';
import { useRecoilValue } from 'recoil';
import { userInformationAtom } from '../../Services/_states';

const MyProfile: React.FC = () => {
    const navigate = useNavigate();
    const userInfo = useRecoilValue(userInformationAtom);
    const [profile, setProfile] = useState<any>(userInfo);

    useEffect(() => {
        if (!userInfo) {
            navigate("/r/login"); 
        } else {
            setProfile(userInfo);
        }
    }, [userInfo, navigate]);

    const breadcrumbsData = [
        { label: <IconButton color='primary'><HomeIcon /></IconButton>, href: "/" },
        { label: 'My Profile' },
    ];

    return (
        <Box sx={{ padding: '10px', backgroundColor: '#f3f4f6', minHeight: '80vh' }}>
            {/* White background for everything inside */}
            <Box sx={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                padding: '30px',
            }}>
                {/* Breadcrumbs */}
                <DynamicBreadcrumbs
                    items={breadcrumbsData}
                    onBreadcrumbClick={(event, item: { label: string, href: string }) => {
                        if (item) {
                            navigate(item?.href);
                        }
                    }}
                />
                
                {/* Title */}
                <Grid container spacing={2} sx={{ alignItems: 'center', marginBottom: '30px' }}>
                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: '#333' }}>
                            My Profile
                        </Typography>
                    </Grid>
                </Grid>

                {/* Profile details container */}
                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                    gap: '30px',
                    paddingTop: '20px',
                }}>
                    {/* First Row: First Name and Last Name */}
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>First Name</Typography>
                        <Typography variant="body1" sx={{ color: '#777' }}>{profile?.first_name || "N/A"}</Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>Last Name</Typography>
                        <Typography variant="body1" sx={{ color: '#777' }}>{profile?.last_name || "N/A"}</Typography>
                    </Box>

                    {/* Second Row: Mobile and Email */}
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>Mobile No.</Typography>
                        <Typography variant="body1" sx={{ color: '#777' }}>{profile?.mobile || "N/A"}</Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>Email ID</Typography>
                        <Typography variant="body1" sx={{ color: '#777' }}>{profile?.email || "N/A"}</Typography>
                    </Box>

                    {/* Third Row: Username and Profile Name */}
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>Username</Typography>
                        <Typography variant="body1" sx={{ color: '#777' }}>{profile?.username || "N/A"}</Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>Your Profile Name</Typography>
                        <Typography variant="body1" sx={{ color: '#777' }}>{profile?.profile?.name || "N/A"}</Typography>
                    </Box>

                    {/* Fourth Row: Organisation Name and Organisation Category */}
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>Your Organisation</Typography>
                        <Typography variant="body1" sx={{ color: '#777' }}>{profile?.profile?.organisation?.name || "N/A"}</Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>Organisation Category</Typography>
                        <Typography variant="body1" sx={{ color: '#777' }}>{profile?.profile?.organisation?.category || "N/A"}</Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default MyProfile;
